<template>
  <div class="Table-wrapper">
    <template v-if="url">
      <div class="Table-controls top">
        <div class="search">
          <input type="text" placeholder="Search" v-model="search" />
          <!-- <div class="Loader Loader--small" v-if="state & states.loading"></div> -->
        </div>

        <div class="paging" v-if="response.pagination">
          <Pagination
            v-model="page"
            :perPage="perPage"
            :numRecords="response.pagination.totalItems"
          ></Pagination>
        </div>
      </div>

      <Loader :url="endpoint"
        v-bind:response="response"
        v-on:ready="response = $event"
      >
        <template slot="result">
          <div class="Table">
            <slot v-bind="response.body"></slot>
            <!-- <div class="Loader" v-if="state & states.loading"></div> -->
          </div>

          <Row class="Row-error" v-if="!response.pagination">
            <div class="text-medium red">No results found.</div>
          </Row>

          <div class="Table-controls bottom" v-if="response.pagination">
            <Pagination
              v-model="page"
              :perPage="perPage"
              :numRecords="response.pagination.totalItems"
            ></Pagination>
          </div>
        </template>
      </Loader>
    </template>

    <div
      class="Table"
      v-else
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import Pagination from './Pagination';
  import Loader from '@/legacy/components/widgets/Loader';
  import { httpBuildQuery } from '@/legacy/lib//util';
  import Row from './Row';

  export default {
    components: {
      Pagination,
      Loader,
      Row
    },

    props: {
      url: {
        type: String
      },

      sort: {
        type: String,
        default: ''
      },

      order: {
        type: String,
        default: 'desc'
      }
    },

    data: function () {
      return {
        states: {
          loading: 0x01,
          ready: 0x02
        },

        state: 0x01,

        endpoint: null,
        response: {},
        qs: {},

        perPage: 15,
        search: this.$route.query.search || '',
        page: 1,
        // sort: '',
        // order: 1
      }
    },

    methods: {
      update () {
        this.qs = Object.assign (
          {
            search: this.search,
            page:   this.page,
            limit:  this.perPage,
            sort:   this.sort,
            order:  this.order
          },

          this.options
        );

        // The loader is watching this for changes.
        this.endpoint = httpBuildQuery (this.url, this.qs);
      }
    },

    created () {
      this.update ();
    },

    watch: {
      search () {
        this.page = 1;
        this.update ();
      },

      sort () {
        this.update ();
      },

      order () {
        this.update ();
      },

      page () {
        this.update ();
      }
    }
  };
</script>

<style lang="scss">
  $w3s-table-icon-height: 50px;

  .Table {
    display: table;
    width: 100%;
    border-collapse: collapse;

    &-wrapper {
    }

    &-controls {
      display: flex;
      flex-direction: row;

      .search {
        width: 400px;
        display: flex;

        input {
          margin-right: 20px;
        }
      }

      .paging {
        flex-grow: 1;
      }

      &.top {
        margin-bottom: 30px;

        .Pagination {
          justify-content: flex-end;
        }
      }

      &.bottom  {
        margin-top: 40px;

        .Pagination {
          justify-content: center;
        }
      }
    }


    &__icon {
      display: flex;
      justify-content: center;
      line-height: $w3s-table-icon-height;

      div {
        margin-right: 8px;
        width: $w3s-table-icon-height;
        height: $w3s-table-icon-height;
      }
    }

    .W3S-bar {
      max-width: 150px;
    }

    &-boundary {
      border-top: 1px solid rgba(var(--white), 0.1) !important;
    }

    &-noborder {
      border: none !important;
    }
  }
</style>